export interface GeographicRegion {
  code: string;
  label: string;
  countryCodes: readonly string[];
}

// Morningstar region groupings, transcribed from the Figma export
// `designer/src/app/components/universe-data.ts` (geoRegions). The codes
// (DNA / ELA / DEU / EEU / DAP / EAS / DMA / EMA) are the same Morningstar
// region codes the eligible-universe config emits as region_code, and the
// country groupings line up 1:1 with STATIC_COUNTRIES in staticClassifications.
export const GEOGRAPHIC_REGIONS: ReadonlyArray<GeographicRegion> = [
  {
    code: 'DNA',
    label: 'North America',
    countryCodes: ['US', 'CA'],
  },
  {
    code: 'ELA',
    label: 'Latin America & Caribbean',
    countryCodes: ['MX', 'BR', 'CL', 'PE', 'CO', 'KY'],
  },
  {
    code: 'DEU',
    label: 'Europe (Developed)',
    countryCodes: [
      'CH', 'GB', 'DE', 'NL', 'FI', 'IT', 'FR', 'BE', 'SE', 'DK',
      'NO', 'IE', 'ES', 'AT', 'PT', 'GR', 'PL',
    ],
  },
  {
    code: 'EEU',
    label: 'Europe (Emerging)',
    countryCodes: ['HU', 'TR', 'CZ', 'RU'],
  },
  {
    code: 'DAP',
    label: 'Asia-Pacific (Developed)',
    countryCodes: ['JP', 'AU', 'HK', 'SG', 'NZ'],
  },
  {
    code: 'EAS',
    label: 'Asia (Emerging)',
    countryCodes: ['KR', 'ID', 'TW', 'MY', 'TH', 'PH', 'IN', 'CN', 'PK'],
  },
  {
    code: 'DMA',
    label: 'Middle East & Africa (Developed)',
    countryCodes: ['IL'],
  },
  {
    code: 'EMA',
    label: 'Middle East & Africa (Emerging)',
    countryCodes: ['ZA', 'MA', 'EG', 'QA', 'KW', 'SA', 'AE'],
  },
];

/** Returns the region code for a given ISO country code. Falls back to 'OTHER'. */
export function getRegionForCountry(countryCode: string): string {
  for (const region of GEOGRAPHIC_REGIONS) {
    if ((region.countryCodes as readonly string[]).includes(countryCode)) {
      return region.code;
    }
  }
  return 'OTHER';
}
